/**
 * Extracts the loyalty level number from a cohort key
 * @param cohortKey - The cohort key (e.g., 'monetary-cohort-tier-1', 'monetary-cohort-base-tier')
 * @returns The level number (1-based indexing)
 *
 * Mapping:
 * - TIER_0 → Level 1
 * - BASE_TIER → Level 2
 * - TIER_1 → Level 3
 * - TIER_2 → Level 4
 * - TIER_3 → Level 5
 * - TIER_4 → Level 6
 */

import { DEFAULT_LEVEL_FOR_USERS_WITH_NO_LEVEL } from '~~/constants/loyaltyProgram';
import { COHORT_TIER_KEY } from '~~/constants/discounts';

export const getLoyaltyLevelNumber = (cohortKey: string | null): number => {

  if (!cohortKey || cohortKey === COHORT_TIER_KEY.NOT_LOGGED_IN) {

    return DEFAULT_LEVEL_FOR_USERS_WITH_NO_LEVEL;
  
  }

  if (cohortKey === 'monetary-cohort-tier-0') {

    return 1;
  
  }

  if (cohortKey === 'monetary-cohort-base-tier') {

    return 2;
  
  }

  const cohortNumber = Number.parseInt(cohortKey
    .replace('monetary-cohort-tier-', ''),
  10);

  return cohortNumber + 2;

};
